import Vue from 'vue'
import Vuex from 'vuex'

// import { isNaN } from 'lodash'

/*
 교육 캘린더 스토어
    - getName 함수 필수 구현
    - createInstance 함수 필수 구현
*/

/*
  return
   - vue intance를 식별하기 위한 unique id
*/
const getName = () => {
  return 'eduCal'
}

/*
   return
    - localstore 저장용 vue instance
*/
const createInstance = () => {
  let localStore = ''

  if (window.vue.getStore(getName) === undefined) {
    const store = new Vuex.Store({
      state: {
        yearList: {}, // 캘린더 목록에 표시가능한 년도
        periodList: {} // 캘린더 목록에 표시가능한 년월일
      },
      getters: {
        yearList: state => {
          return state.yearList
        },
        periodList: state => {
          return state.periodList
        }
      },
      mutations: {
        SET_YEAR_LISET (state, yearList) {
          state.yearList = yearList
        },
        SET_PERIOD_LIST (state, periodList) {
          state.periodList = periodList
        }
      },
      actions: {
        // 캘린더 표시 연도 조회
        async selectEduCalendarCond (context, payload) {
          var httpObj = window.vue.getInstance('http')
          try {
            var res = await httpObj.b2c.selectEduCalendarCond(this, payload.data)
            if (res.data.status === 'OK') {
              context.commit('SET_YEAR_LISET', res.data.data.yearList) // 캘린더 목록에 표시가능한 년도
              context.commit('SET_PERIOD_LIST', res.data.data.periodList) // 캘린더 목록에 표시가능한 년월일
              if (payload.callback) {
                payload.callback(res.data.data)
              }
            }
          } catch (e) {
            console.log(e)
          }
        }
      }
    })

    // local vuex 용 vue instance 추가
    localStore = new Vue({
      store: store
    })
  }

  return localStore
}

var store = {}
store.getName = getName
store.createInstance = createInstance

export default store



// WEBPACK FOOTER //
// ./src/config/vuex/nrw/eduCal.js